import "./notification.css";
import CloseSucess from "../../../assets/svgs/CloseSucess.svg";

interface ErrorProps {
  label?: string;
  backgroundError: string;
  colorError?: string;
  id?: string;
  widthError?: string;
  top?: string;
  margin?: string;
  setNotification: any;
  img?: string;
  classNameAux?: any;
}

export const Notification = ({
  label,
  backgroundError,
  colorError,
  top,
  widthError,
  setNotification,
  margin,
  img,
  classNameAux,
}: ErrorProps) => {
  return (
    <div
      className={`containerNotification containerErroSmall ${classNameAux}`}
      data-testid="notification"
      style={{
        backgroundColor: backgroundError,
        color: colorError,
        width: widthError,
        top: top,
        marginRight: margin,
      }}
    >
      <img src={img} alt="icone" className="iconErro" />
      <span
        dangerouslySetInnerHTML={{ __html: label || "" }}
        className="labelErro"
      />

      <button
        type="button"
        onClick={() => setNotification(false)}
        aria-label="Fechar notificação"
        className="CloseMensageError"
      >
        <img className="iconClose" src={CloseSucess} alt="" />
      </button>
    </div>
  );
};

export default Notification;
